import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMediaStyling } from '@hellodarwin/core/lib/components/common/Media';
import Div from '@hellodarwin/core/lib/components/common/div';
import { useTheme } from 'styled-components';
import IntroDescription from '../components/IntroDescription';
import IntroTitle from '../components/IntroTitle';
const width = 640;
const IndentIntro = (props) => {
    const theme = useTheme();
    const bodyCSS = useMediaStyling({
        default: {
            paddingLeft: theme.spacing.xxxl,
            maxWidth: width,
            position: 'relative',
        },
        tablet: { paddingLeft: 0 },
    });
    return (_jsxs(Div, { flex: "column", gap: theme.spacing.md, style: { maxWidth: '100%', width, flex: 1 }, children: [_jsx(IntroTitle, Object.assign({ style: { maxWidth: width } }, props)), _jsx(IntroDescription, Object.assign({}, props, { style: bodyCSS, withBorder: "left" }))] }));
};
export default IndentIntro;
